import { render, staticRenderFns } from "./mobileKnowDynamic.vue?vue&type=template&id=3686fa4a&scoped=true"
import script from "./mobileKnowDynamic.vue?vue&type=script&lang=js"
export * from "./mobileKnowDynamic.vue?vue&type=script&lang=js"
import style0 from "./mobileKnowDynamic.vue?vue&type=style&index=0&id=3686fa4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3686fa4a",
  null
  
)

export default component.exports